export default "__VITE_ASSET__c4320d02__"